import { message, Modal } from "antd";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { generateRandomString } from "utils/helper";
import * as services from "../services/socialSecurityContributionApi";
import { setCurrentSocialSecurityContribution, setIsLoading } from "../slices/socialSecurityContributionSlice";
import { useTranslation } from "react-i18next";

function toParams(values = {}) {
  const modifiedValues = {
    ...values,
  };
  return modifiedValues;
}

function useSocialSecurityContributionEdit(props) {
  const { onCancel = () => { } } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.socialSecurityContribution.isLoading);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentSocialSecurityContribution = useSelector(
    (state) => state.socialSecurityContribution.currentSocialSecurityContribution
  );
  const { t } = useTranslation();

  const getSocialSecurityContribution = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getSocialSecurityRate({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      dispatch(setCurrentSocialSecurityContribution(response.data));
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);

  const updateSocialSecurityContribution = useCallback(async (params) => {
    try {
      dispatch(setIsLoading(true));
      const result = await services.updateSocialSecurityRate(
        toParams({ ...params, companyId: currentCompany })
      );
      onCancel(true);
      message.success(t("common.success"))
    } catch (error) {
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [dispatch, onCancel, currentCompany]);

  useEffect(() => {
    if (currentCompany && typeof currentCompany !== "object") {
      getSocialSecurityContribution();
    }
  }, [currentCompany, getSocialSecurityContribution]);

  const onSubmit = useCallback(
    (values) => {
      Modal.confirm({
        title: t('dialog.confirmation.header'),
        content: (
          <>
            <p>{t('are-you-sure-confirm-to-update')}</p>
          </>
        ),
        onOk() {
          updateSocialSecurityContribution(values);
        },
        okText: t('reset.confirm'),
        cancelText: t('action.cancel'),
      });
    },
    [updateSocialSecurityContribution]
  );

  return { isLoading, currentSocialSecurityContribution, onCancel, onSubmit };
}

export default useSocialSecurityContributionEdit;
